
// window loaded
document.addEventListener('DOMContentLoaded', function() {

if (window.location.pathname.includes('/products/')){
  
  var customSizeDropdown = document.getElementById('custom-size-dropdown');
  var cutSizesInput = document.getElementById('cut-sizes-input');
  var numberOfSizesInput = document.getElementById('number-of-sizes');
  var sizesContainer = document.getElementById('sizes-container');
  var customSizesInput = document.getElementById('custom-sizes');
  var productTagsElement = document.getElementById('product-tags');
  var productTags = productTagsElement ? productTagsElement.getAttribute('data-tags').split(',') : [];
  var targetTags = ['custom-cuts-sizes']; // Update with your target tags

// function to add css Style
  showCustomSizeOption();


// Checking product tag & getting dropdown for custom size & adding css style - Working
  function showCustomSizeOption() {
    for (var i = 0; i < productTags.length; i++) {
      if (targetTags.includes(productTags[i].trim())) {
        document.getElementById('custom-size-option').style.display = 'block'; 
        document.querySelector('#custom-size-option select').style.cssText = 'font-family: inherit; background-color: #0B6CFF; color: white;';
        document.querySelector('#custom-size-option select option').style.cssText = 'background-color:white; color:blue; font-weight:bold;';
        break;
      }
    }
  }

// Event Listener to check Yes value from dropdown adding field for custom sizes and generate button - Working

  customSizeDropdown.addEventListener('change', function() {
    if (customSizeDropdown.value === 'yes') {
      cutSizesInput.style.display = 'block';

      // Only add the button if it doesn't exist
      if (!document.getElementById('generate-sizes')) {
        var generateSizesButton = document.createElement('button');
        generateSizesButton.setAttribute('type', 'button');
        generateSizesButton.setAttribute('id', 'generate-sizes');
        generateSizesButton.textContent = 'Enter Cut Sizes';
        cutSizesInput.appendChild(generateSizesButton);
        generateSizesButton.style.cssText = 'font-family: Roboto; background-color:#0B6CFF; color:#ffffff; padding:1.2rem 2.5rem; font-size:1.5rem; margin:5px 0px;';          


	// Generating fields according to the user input value		
        generate_size_and_textField(generateSizesButton);
      }
      
    } else {
      cutSizesInput.style.display = 'none';
      sizesContainer.innerHTML = '';
    }
  });

	// Generating fields according to the user input value	- Working
  function generate_size_and_textField(generateSizesButton) {
    generateSizesButton.addEventListener('click', function() {

      generateSizesButton.innerHTML = "Update Cut Sizes Quantity"
      var numberOfSizes = parseInt(numberOfSizesInput.value);
      sizesContainer.innerHTML = ''; // Clear previous inputs

      if (numberOfSizes >= 13) {
        
        var callButtonError = document.createElement('div');
        callButtonError.innerText = 'Please Call For Larger Cut Quantities than 12. Thanks';
        callButtonError.style.color = 'red';
        callButtonError.style.fontSize = '18px';
        sizesContainer.appendChild(callButtonError);
        var callButton = document.createElement('div');
        callButton.innerText = 'Call +1 864 469-9129';
        callButton.setAttribute('type', 'button');
        sizesContainer.appendChild(callButton);
        callButton.innerHTML = '<a href="tel:+18644699129" style="color:#ffffff; text-decoration:none;">Call +1 864 469-9129</a>'; 
        callButton.style.cssText = 'font-family: Roboto; background-color:#0B6CFF; color:#ffffff; padding:1.2rem 2.5rem; font-size:1.5rem; margin:5px 0px;'; 
        callButton.style.width = '50%';
        callButton.style.margin = '10px 0px'; // Centers the div horizontally


      } else {

     //   if (numberOfSizes <= 1){

      //  var zero_or_one_quantity = document.createElement('div');
      //  var zero_or_one_quantity_p = document.createElement('p');
      //  zero_or_one_quantity.appendChild(zero_or_one_quantity_p);
       // zero_or_one_quantity_p.innerText = 'Please Enter alteast 2 Cut Sizes';
      //  zero_or_one_quantity_p.style.cssText = 'font-family: Roboto; color:red; font-size:18px;';
       // sizesContainer.appendChild(zero_or_one_quantity);


//}else{
          
        for (var i = 1; i <= numberOfSizes; i++) {
          var sizeDiv = document.createElement('div');
          var sizeLabel = document.createElement('label');
          sizeLabel.setAttribute('for', 'size-' + i);
          sizeLabel.innerText = 'Enter Cut Size #' + i + ' (in inches) + $4.00';
          sizeLabel.style.fontWeight = 'bold';  // Make label bold

          var sizeInput = document.createElement('input');
          sizeInput.setAttribute('type', 'text');
          sizeInput.setAttribute('id', 'size-' + i);
          sizeInput.setAttribute('name', 'cut_sizes[]');
          sizeInput.setAttribute('placeholder', 'Example: 24 x 32.5');
          sizeInput.setAttribute('required', 'required');
          sizeInput.setAttribute('class', 'size-inputs');
          sizeDiv.appendChild(sizeLabel);
          sizeDiv.appendChild(sizeInput); 
          sizeDiv.style.marginTop = "5px";
          sizesContainer.appendChild(sizeDiv);    
        }
        var wastage_warning = document.createElement('div');  
        wastage_warning.innerText = 'Only Cut Sizes will be Shipped, Remaining leftover will not be shipped';
        wastage_warning.style.color = 'black';
        wastage_warning.style.fontSize = '14px';
        wastage_warning.style.fontWeight = 'bold';
        sizesContainer.appendChild(wastage_warning);
        sizesContainer.style.marginBottom = "10px";
     // }
      }
    });
  }

  var addToCartButton = document.querySelector('.button-add-to-cart');
  if (addToCartButton) {
    addToCartButton.addEventListener("click", handleAddToCartClick);
  }

  var shopifyPaymentButton = document.querySelector('.shopify-payment-button__button--branded');
  if (shopifyPaymentButton) {
    shopifyPaymentButton.addEventListener("click", handleAddToCartClick);
  } 
 
  var shopifyMorePaymentOptionsButton = document.querySelector('.shopify-payment-button__more-options');
  if (shopifyPaymentButton) {
    shopifyMorePaymentOptionsButton.addEventListener("click", handleAddToCartClick);
  }

 
// Add to cart event Click
  function handleAddToCartClick(e) {
    e.preventDefault();

	// checking if custom sizes value is available 
	// if not it will set the value to default
	// if yes it will run cs_doc_finding_value function - 
	// cs_doc_finding_value function - getting input values and finding higest dimension
	// getting values and finding higest dimension
	// running cs_value_update function - updating value of line item property according to the highest dimension condition for shipping method
	// 
	

    // checking if user has entered custom sizes or not if not so it will set property value to default
    // Check if custom sizes value is available and validate
    if (!if_custom_sizes()) {
        return; // Prevent form submission if validation fails
    }

    var form = e.target.closest('form');
    if (form) {
        var productId = document.querySelector('.product-form-input input[type="radio"]:checked').dataset.variantId;
        var quantity = document.querySelector('input[name="quantity"]').value;
        
        // Remove existing line item properties
        form.querySelectorAll('input[name^="properties[custom_size_"]').forEach(input => input.remove());

        cs_adding_line_item_properties(productId, quantity).then(() => {
            // Only submit the form if validation and line item properties addition are successful
            setTimeout(function() {
                form.submit();
            }, 1000);
        }).catch(error => console.error('Error:', error));
    }
	
  }

// Adding line item property - and calling add to cart function for variant 

function cs_adding_line_item_properties(productId, quantity) {
  return new Promise((resolve, reject) => {
    var sizesContainer = document.getElementById('sizes-container');
    var sizeInputs = sizesContainer.querySelectorAll('input[type="text"]');
    var customProperties = {};
    var customSizes = [];
    var ref_id_date = new Date().getTime();

    var adding_line_item_for_quantity = document.createElement('input');
    adding_line_item_for_quantity.setAttribute('type', 'hidden');
    adding_line_item_for_quantity.setAttribute('name', 'properties[Clearly - Product Quantity]');
    adding_line_item_for_quantity.setAttribute('value', ''); // You can set an initial value if needed
    sizesContainer.closest('form').appendChild(adding_line_item_for_quantity);
    adding_line_item_for_quantity.setAttribute('value', quantity);

       // Create the hidden input for "properties[Custom Sizes]"
    var customSizesInput = document.createElement('input');
    customSizesInput.setAttribute('type', 'hidden');
    customSizesInput.setAttribute('name', 'properties[Custom Sizes]');
    customSizesInput.setAttribute('value', ''); // You can set an initial value if needed
    sizesContainer.closest('form').appendChild(customSizesInput);
    customSizesInput.setAttribute('value', sizeInputs.length * quantity);  

      var cs_token_id = document.createElement('input');
    cs_token_id.setAttribute('type', 'hidden');
    cs_token_id.setAttribute('name', 'properties[tokenID]');
    cs_token_id.setAttribute('value', ''); // You can set an initial value if needed
    sizesContainer.closest('form').appendChild(cs_token_id);
    cs_token_id.setAttribute('value', ref_id_date.toString());
    
   sizeInputs.forEach(function(input, index) {
      if (input.value.trim()) {
        for (var i = 0; i < quantity; i++) { // Loop to account for quantity
          var propertyInput = document.createElement('input');
          propertyInput.setAttribute('type', 'hidden');
          propertyInput.setAttribute('name', 'properties[sheet_' + (i + 1) + '_custom_size_' + (index + 1) + ']');
          propertyInput.setAttribute('value', input.value.trim().toLowerCase());
          input.closest('form').appendChild(propertyInput);
          customProperties['custom_size_' + (index + 1) + '_' + (i + 1)] = input.value.trim();
          customSizes.push(propertyInput.getAttribute('value'));
        }
      }
      
    });
    

    console.log(customSizes);
    console.log('Custom Properties:', customProperties);


    var customFeeProductId = '45722883948789'; // Custom Cut Fee product's variant ID
    var customFeeQuantity = customSizes.length;
    var custom_product_property = {}
    custom_product_property.productId = productId
    custom_product_property.tokenID = ref_id_date.toString();

    addToCart(customFeeProductId, customFeeQuantity, custom_product_property).then(() => {
      resolve();
    }).catch(error => {
      console.error('Error adding custom fee to cart:', error);
      reject(error);
    });
  });
}




function addToCart(productId, quantity, customProperties) {
  
// New Change

  
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity,
        properties: customProperties
      })
    })
    .then(response => {
      if (response.redirected) {
        console.error('Unexpected redirection:', response.url);
        return;
      }
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(`HTTP error! status: ${response.status}, message: ${err.message}`);
        });
      }
      return response.json();
    })
    .then(data => {
      console.log('Success:', data);
    })
    .catch(error => console.error('Error:', error));
  }


// Updated if_custom_sizes function
function if_custom_sizes() {


var custom_sizes_check = document.getElementById('custom-size-option');
var default_variant_check = document.querySelector('.product-form-input input[name="Size"]:checked');



if (custom_sizes_check.style.display === 'none'){
// if custom cuts tag is not on prodcut page

if (!default_variant_check){
// if custom cut tag not available & also variant is not available 

console.log ("if custom cut tag not available & also variant is not available");
return true;
}else{

// if custom cut tag not available but variant is available - So it will pass the highest variant value to cs_value_update

console.log ("if custom cut tag not available but variant is available - So it will pass the highest variant value to cs_value_update");

      
    var highestDimension = 0;
    var variantSize = document.querySelector('.product-form-input input[name="Size"]:checked');
    var quantity = document.querySelector('input[name="quantity"]').value;
    // Step 1: Remove commas from the variant size
    var cleanedVariantSize = variantSize.value.replace(/,/g, '');

    // Step 2: Convert variant size from feet to inches
    var dimensionsInFeet = cleanedVariantSize.toLowerCase().split('x').map(value => parseFloat(value.trim()));
    var dimensionsInInches = dimensionsInFeet.map(value => value * 1); // Convert feet to inches
    var maxDimension = Math.max(dimensionsInInches[0], dimensionsInInches[1]);

          var variant_dimension_width = dimensionsInInches[0];
          var variant_dimension_height = dimensionsInInches[1];


      cs_value_update(maxDimension, variant_dimension_width, variant_dimension_height)
        return true; // Default case where no custom sizes means no validation needed

}

}else{
// if custom cuts tag is on prodcut 

    var cuts_sizes_length = document.querySelectorAll("#sizes-container input").length; 

    if (cuts_sizes_length > 0) { 
// if custom cuts tag is on prodcut so it will check if its greater than 0

console.log("// if custom cuts tag is on prodcut so it will check if its greater than 0");

        return validating_custom_sizes(); // Return the validation result

    } else {
// if custom cuts tag is on prodcut so it will check if its greater than 0

console.log("// if custom cuts tag is on prodcut but value is not there");

      
    var highestDimension = 0;
    var variantSize = document.querySelector('.product-form-input input[name="Size"]:checked');
    var quantity = document.querySelector('input[name="quantity"]').value;

    // Step 1: Remove commas from the variant size
    var cleanedVariantSize = variantSize.value.replace(/,/g, '');

    // Step 2: Convert variant size from feet to inches
    var dimensionsInFeet = cleanedVariantSize.toLowerCase().split('x').map(value => parseFloat(value.trim()));
    var dimensionsInInches = dimensionsInFeet.map(value => value * 1); // Convert feet to inches
    var maxDimension = Math.max(dimensionsInInches[0], dimensionsInInches[1]);

          var variant_dimension_width = dimensionsInInches[0];
          var variant_dimension_height = dimensionsInInches[1];


      cs_value_update(maxDimension, variant_dimension_width, variant_dimension_height)
        return true; // Default case where no custom sizes means no validation needed

}


}
}

// Updated validating_custom_sizes function
function validating_custom_sizes() {

    var variantSize = document.querySelector('.product-form-input input[name="Size"]:checked').value;
    var quantity = document.querySelector('input[name="quantity"]').value;

    // Step 1: Remove commas from the variant size
    var cleanedVariantSize = variantSize.replace(/,/g, '');

    // Step 2: Convert variant size from feet to inches
    var dimensionsInFeet = cleanedVariantSize.toLowerCase().split('x').map(value => parseFloat(value.trim()));
    var dimensionsInInches = dimensionsInFeet.map(value => value * 1); // Convert feet to inches


    // Calculate total area of the variant size
    var totalVariantArea = (dimensionsInInches[0] * dimensionsInInches[1]) * quantity;
    console.log("total Variant Area = " + totalVariantArea);

    var userInputs = document.querySelectorAll('#sizes-container input');
    var fieldsExceptFirst = Array.from(userInputs);

    // Initialize total user area
    var totalUserArea = 0;
    var highestDimension = 0;
    var user_dimension_width = 0;
    var user_dimension_height = 0;
    var isValid = true; // Initialize validation flag
    var totalUserArea = 0; // Initialize total user area


    fieldsExceptFirst.forEach(function (userInput) {
        // Check for special characters
        var specialCharMatch = userInput.value.toLowerCase().match(/[^0-9x\s.]/);
        if (specialCharMatch) {
            var invalidDiv = userInput.parentNode.querySelector('#error_sizes_check');
            if (!invalidDiv) {
                invalidDiv = document.createElement('div');
                invalidDiv.setAttribute('id', 'error_sizes_check');
                invalidDiv.style.color = 'red';
                userInput.parentNode.appendChild(invalidDiv);
            }
            invalidDiv.innerHTML = 'Special character "' + specialCharMatch[0] + '" is not allowed. Please enter dimensions in the format width x height (12 x 32.5).';
            isValid = false; // Set validation flag to false
        } else {
            // Step 3: Split the user input and convert to numbers
            var userDimensions = userInput.value.toLowerCase().split('x').map(value => parseFloat(value.trim()));
 

            // Check if an error div already exists
            var existingErrorDiv = userInput.parentNode.querySelector('#error_sizes_check');
            if (!existingErrorDiv) {
                var invalidDiv = document.createElement('div');
                invalidDiv.setAttribute('id', 'error_sizes_check');
                invalidDiv.style.color = 'red';
                userInput.parentNode.appendChild(invalidDiv);
            } else {
                invalidDiv = existingErrorDiv;
            }

            // Clear previous error message
            invalidDiv.innerHTML = '';

            // Validate the user input
            if (userDimensions.length === 2) {
                if (isNaN(userDimensions[0]) || isNaN(userDimensions[1])) {
                    invalidDiv.innerHTML = 'Invalid dimensions, please enter numbers in the format width x height (12 x 32.5)';
                    isValid = false; // Set validation flag to false
                } else {
                    var userArea = userDimensions[0] * userDimensions[1];
                    totalUserArea += userArea;            
                    console.log("total user Area = " + totalUserArea);

                    /*if (userDimensions[0] > dimensionsInInches[0] || userDimensions[1] > dimensionsInInches[1]) {
                        invalidDiv.innerHTML = 'Dimensions are invalid. They should not exceed ' + dimensionsInInches[0] + ' x ' + dimensionsInInches[1] + ' inches.'; // We can suggest different variant size here
                        isValid = false; // Set validation flag to false
                    } else */if (totalUserArea > totalVariantArea) {
                        invalidDiv.innerHTML = 'Total cut dimensions exceed sheet size. Please increase quantity'; // We can suggest adding quantity here
                        isValid = false; // Set validation flag to false
                    } else {
                        invalidDiv.innerHTML = ''; // Clear the error message if valid
                        var maxDimension = Math.max(userDimensions[0], userDimensions[1]);
                        if (maxDimension > highestDimension) {
                            highestDimension = maxDimension;
                           user_dimension_width = userDimensions[0];
                           user_dimension_height = userDimensions[1];
                        }  
                    }
                }
            } else {
                if (!userDimensions[0] && !userDimensions[1]) {
                    invalidDiv.innerHTML = "Please enter the dimensions (width x height)";
                    isValid = false; // Set validation flag to false
                } else if (!userDimensions[0]) {
                    invalidDiv.innerHTML = "Please enter the width";
                    isValid = false; // Set validation flag to false
                } else if (!userDimensions[1]) {
                    invalidDiv.innerHTML = "Please enter the height";
                    isValid = false; // Set validation flag to false
                }
            }
        }
    });
  console.log("valid value is "+isValid);
if (isValid) {
    cs_value_update(highestDimension, user_dimension_width, user_dimension_height); // Use user dimensions instead of variant dimensions
}
    return isValid; // Return the validation result
}

  
  // updating value of line item property according to the highest dimension condition for shipping method
  
  function cs_value_update(highestDimension, user_dimension_width, user_dimension_height) 
  {
  
      console.log("if cs_value_update  Max Dimenstion set to : " + highestDimension )
      console.log("if cs_value_update  Max Width set to : " + user_dimension_width )
      console.log("if cs_value_update  Max Height set to : " + user_dimension_height )
  
       var minDimension = Math.min(user_dimension_width, user_dimension_height);
    
  
      var shippingCategory = '';
      // if highest dimension greater than 48 shipping will be tractor tailor
      if (highestDimension > 48) 
      {
          if(minDimension <= 24 && highestDimension <= 90)
          {
              shippingCategory = 'Extra Large UPS';
          }
          else
          {
              shippingCategory = 'Tractor Trailer';
          }
          
      } 
      else
      {
          if(minDimension > 32) 
          {
              shippingCategory = 'Extra Large UPS';
          } 
          else
          {
              if(highestDimension > 24 && minDimension >24 ) 
              {
                shippingCategory = 'UPS Large';
              } 
              else 
              {
                shippingCategory = 'Default';
              }
          }
            
      }
      
      console.log(shippingCategory);
      
      
        
          var shippingCategoryInput = document.getElementById('custom-property');
          if (shippingCategoryInput) {
            shippingCategoryInput.value = shippingCategory;
          }
    
      //ending of function
  }
  
// function cs_value_update(highestDimension, user_dimension_width, user_dimension_height) 
// {
//     console.log("if cs_value_update  Max Dimenstion set to : " + highestDimension)
//     console.log("if cs_value_update  Max Width set to : " + user_dimension_width)
//     console.log("if cs_value_update  Max Height set to : " + user_dimension_height)

//     var minDimension = Math.min(user_dimension_width, user_dimension_height);
//     var shippingCategory = '';
    
//     // New condition for Clearly plastic - if width < 90" AND width < 25"
//     if (highestDimension > 48 && !(user_dimension_width < 90 && user_dimension_width < 25))
//     {
//         shippingCategory = 'Tractor Trailer';
//     }
//     else if (highestDimension <= 48)
//     {
//         console.log("equals to 48 condition")
//         // if variant width or height less than 48 shipping will be UPS
//         if(minDimension > 36){
//             shippingCategory = 'Extra Large UPS';
//         }else{
//             shippingCategory = 'UPS Large';
//         }
//     }
//     else 
//     {
//         // This handles the case where highestDimension > 48 but width < 90 and width < 25
//         console.log("Clearly plastic special case - Extra Large UPS")
//         shippingCategory = 'Extra Large UPS';
//     }
    
//     console.log(shippingCategory);
    
//     var shippingCategoryInput = document.getElementById('custom-property');
//     if (shippingCategoryInput) {
//         shippingCategoryInput.value = shippingCategory;
//     }
//     //ending of function
// }

  
}
if (window.location.pathname == "/cart"){


// Run the checkAndClearCart function when the cart page loads
window.addEventListener('DOMContentLoaded', checkAndClearCart)

function checkAndClearCart() {
    fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch cart data');
            }
            return response.json();
        })
        .then(cart => {
            // Check if the cart has only one item and its variant ID matches the given ID
            if (cart.items.length === 1 && cart.items[0].variant_id === 45722883948789) {
                // Clear the cart
                clearCart();
            }
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
}

// Function to clear the cart
function clearCart() {
    fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch cart data');
            }
            return response.json();
        })
        .then(cart => {
            console.log('Cart Data:', cart);

            const updates = {};
            cart.items.forEach(item => {
                updates[item.key] = 0; // Set the quantity of each item to 0
            });

            console.log('Updates Payload:', JSON.stringify(updates));

            return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    updates: updates
                })
            });
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(`HTTP error! status: ${response.status}, message: ${err.message}`);
                });
            }
            return response.json();
        })
        .then(data => {
            console.log('Success:', data);
            location.reload(); // Reload the cart page to reflect the changes
        })
        .catch(error => console.error('Error:', error));
}

// Function to attach event listeners to remove buttons
function attachEventListeners() {
    fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch cart data');
            }
            return response.json();
        })
        .then(cart => {
            console.log('Cart:', cart); // Debugging: Check the cart object


            // Loop through cart items and prepare data for each item
            cart.items.forEach(cartItem => {
     
             var to_updated_cart_item_object = getting_variant_setting(cartItem)
              
              getting_remove_button_setting_only_for_same_tokenID(cartItem, to_updated_cart_item_object);

            });
        })
        .catch(error => {
            console.error('Error fetching cart:', error); // Debugging: Log errors
        });
}

              
          function getting_variant_setting(cartItem){
             var cart_item_object = {};
           if (cartItem.properties.productId) {

const cut_fee_variant_id = cartItem.variant_id;
const cut_fee_product_ref_id = cartItem.properties.productId  
const propertiesKey = "productId";
cart_item_object.cs_cut_fee_variant_id = cut_fee_variant_id
cart_item_object.cs_cut_fee_product_ref_id = cut_fee_product_ref_id
cart_item_object.cs_propertiesKey = propertiesKey
cart_item_object.cs_tokenID = cartItem.properties.tokenID                
                }   
            return cart_item_object;
     }


function getting_remove_button_setting_only_for_same_tokenID(cartItem, to_updated_cart_item_object){
// object containing cs_cut_fee_variant_id, cs_cut_fee_product_ref_id, cs_propertiesKey, cs_tokenID

setTimeout(function(){

if (to_updated_cart_item_object && cartItem.properties && cartItem.properties.tokenID && cartItem.properties.tokenID == to_updated_cart_item_object.cs_tokenID){


                    const itemElement = document.querySelector(`.cart-item[data-custom-property="${to_updated_cart_item_object.cs_tokenID}"]`); // Adjust selector to match your theme
                    const removeButton = itemElement ? itemElement.querySelector('.button-cart-remove') : null; // Adjust selector to match your theme

                      console.log('Item Element:', itemElement); // Debugging: Check if itemElement is found
                    console.log('Remove Button:', removeButton); // Debugging: Check if removeButton is found

        if (removeButton) {
            // Remove existing event listeners
            removeButton.replaceWith(removeButton.cloneNode(true));
            // Re-select the cloned button
            const newRemoveButton = itemElement.querySelector('.button-cart-remove');

            // Attach event listener
            newRemoveButton.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                clearCart_update(event, to_updated_cart_item_object);
            });
        }
  

}else if (cartItem.properties["Custom Sizes"] && cartItem.properties["Custom Sizes"] == 0) {
                    var without_id_cart_buttons = document.querySelectorAll(`.cart-item[data-variant-id="${cartItem.variant_id}"]`);
                    without_id_cart_buttons.forEach(function(without_id_cart_button) {
                        const withoutId_removeButton = without_id_cart_button ? without_id_cart_button.querySelector('.button-cart-remove') : null; // Adjust selector to match your theme

                        if (withoutId_removeButton) {
                            withoutId_removeButton.addEventListener('click', function() {
                                setTimeout(function() {
                                    updateCart();
                                }, 1500);
                            });
                        }
                    });
                }

}, 1000)

  


}


  
function getting_remove_button_setting(cartItem, to_updated_cart_item_object){
           
if (to_updated_cart_item_object && to_updated_cart_item_object.cs_cut_fee_product_ref_id){
  
  console.table(to_updated_cart_item_object)
  console.log("my condition working")

setTimeout(function(){
                    const itemElement = document.querySelector(`.cart-item[data-custom-property="${to_updated_cart_item_object.cs_tokenID}"]`); // Adjust selector to match your theme

                    console.log("this is item element")
                    console.log(itemElement)
                    const removeButton = itemElement ? itemElement.querySelector('.button-cart-remove') : null; // Adjust selector to match your theme

                      console.log('Item Element:', itemElement); // Debugging: Check if itemElement is found
                    console.log('Remove Button:', removeButton); // Debugging: Check if removeButton is found

        if (removeButton) {
            // Remove existing event listeners
            removeButton.replaceWith(removeButton.cloneNode(true));
            // Re-select the cloned button
            const newRemoveButton = itemElement.querySelector('.button-cart-remove');

            // Attach event listener
            newRemoveButton.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                clearCart_update(event, to_updated_cart_item_object);
            });
        }
}, 1500)
}else if (cartItem.properties["Custom Sizes"] && cartItem.properties["Custom Sizes"] == 0) {
                    var without_id_cart_buttons = document.querySelectorAll(`.cart-item[data-variant-id="${cartItem.variant_id}"]`);
                    without_id_cart_buttons.forEach(function(without_id_cart_button) {
                        const withoutId_removeButton = without_id_cart_button ? without_id_cart_button.querySelector('.button-cart-remove') : null; // Adjust selector to match your theme

                        if (withoutId_removeButton) {
                            withoutId_removeButton.addEventListener('click', function() {
                                setTimeout(function() {
                                    updateCart();
                                }, 1500);
                            });
                        }
                    });
                }
            
          }
  


// Attach event listeners initially
attachEventListeners();


function clearCart_update(event, to_updated_cart_item_object) {
    var item_toUpdatetokenID = to_updated_cart_item_object.cs_tokenID;
    const updates = {};

    // Fetch the cart to get current items
    fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch cart data');
            }
            return response.json();
        })
        .then(cart => {
            // Iterate through cart items and find those with the matching tokenID
            cart.items.forEach(item => {
                if (item.properties.tokenID === item_toUpdatetokenID) {
                    updates[item.key] = 0; // Set the quantity of matching items to 0
                }
            });

            // If no items were found with the given tokenID, return early
            if (Object.keys(updates).length === 0) {
                console.warn('No items found with the specified tokenID.');
                return;
            }

            // Send the update request to Shopify
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            });
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(`HTTP error! status: ${response.status}, message: ${err.message}`);
                });
            }
            return response.json();
        })
        .then(data => {
            console.log('Success:', data);
            location.reload(); // Reload the cart page to reflect the changes
        })
        .catch(error => console.error('Error:', error));
}



// Optionally, re-attach event listeners after any cart update
//document.addEventListener('cart:updated', attachEventListeners);

function updateCart() {
    // Dispatch the cart:updated event
    const event = new Event('cart:updated');
    document.dispatchEvent(event);

    // Reload the page to update the cart and re-attach event listeners
    location.reload();

}
  
document.addEventListener('cart:updated', attachEventListeners);

}
});
